import _ from "lodash";
import React from "react";
import classes from "./CustomMessage.scss";
import { Avatar, TextAreaInput } from "@toddle-edu/ds-web";
import { getAvatarColor } from "Utils";
import {
  getDefaultNameSortPreference,
  getDefaultStudentNameOrderPreference,
} from "modules/CommonSelectors";
import { connect } from "react-redux";
import { getFormattedNameForUserType } from "MessagingV2/modules/Utils";
import { getCommentDisplayContent } from "Utils/RegexHelper";
import classNames from "classnames";
import { AttachmentList } from "Attachment";
import { useI18n } from "Hooks";

const styles = {
  horizontalCardStyle: {
    maxWidth: "288px",
  },
  attachmentContainerStyle: {
    gridGap: "8px",
  },
};

const CustomMessage = props => {
  const {
    customMessage,
    setCustomMessage,
    parentMessage,
    defaultStudentNameOrderPreference,
    defaultNameSortPreference,
  } = props;

  const { t } = useI18n(["common"]);

  const onUpdateMessage = params => {
    setCustomMessage(params);
  };

  const { label, createdBy, attachments = [] } = parentMessage;

  const userName = getFormattedNameForUserType({
    user: createdBy,
    orderBy: defaultNameSortPreference,
    defaultStudentNameOrderPreference,
    isFormattedNameV2: true,
  });

  const filteredLabel = getCommentDisplayContent(label, {
    getHtml: item => `@${item}`, // without highlighting in parent message
    renderLinksAsAnchor: false,
    newLineReplaceWith: "\n", // keep it as it is
  });

  const labelContainerClass = classNames(classes.labelContainer, "text-body-2");
  return (
    <div className={classes.container}>
      <TextAreaInput
        name={"title"}
        value={customMessage}
        minRows={5}
        placeholder={t("common:type_your_message_here")}
        onChange={e => onUpdateMessage(e.target.value)}
      />
      <div className={classes.parentMessageContainer}>
        <div className={classes.userDetailsContainer}>
          <Avatar
            shade="light"
            size="xxx-small"
            src={_.get(createdBy, "profileImage", null)}
            shape="square"
            color={getAvatarColor(_.get(createdBy, "id", null))}
            name={`${_.get(createdBy, "firstName")} ${_.get(
              createdBy,
              "lastName"
            )}`}
          />
          <div className="text-label-4">{userName}</div>
        </div>
        <div className={labelContainerClass}>{filteredLabel}</div>
        {_.size(attachments) ? (
          <div className={classes.attachmentContainer}>
            <AttachmentList
              value={attachments}
              mode="view"
              mediaCardSize="medium"
              cardType={"design-media-card"}
              showAttachmentAsPost={false}
              horizontalCardStyle={styles.horizontalCardStyle}
              attachmentContainerStyle={styles.attachmentContainerStyle}
            />
          </div>
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  defaultNameSortPreference: getDefaultNameSortPreference(state),
  defaultStudentNameOrderPreference: getDefaultStudentNameOrderPreference(
    state
  ),
});

export default connect(mapStateToProps, null)(CustomMessage);
